import React from "react";
import { Navigation } from "../components/Navigation";

/* Pagine legali in tema dark (nero/rosa), coerenti con la home. */

const SectionTitle = ({ children }) => (
  <h2 className="text-xl font-bold text-white mb-3">{children}</h2>
);

const LegalShell = ({ children, testid }) => (
  <div className="min-h-screen bg-[#0a0a0f]">
    <Navigation />
    <div className="max-w-4xl mx-auto px-4 py-10">
      <div className="bg-[#12121a] border border-gray-800 rounded-xl p-8" data-testid={testid}>
        {children}
      </div>
      <div className="text-center mt-8">
        <a href="/" className="text-pink-400 hover:text-pink-300 font-medium">← Torna alla Homepage</a>
      </div>
    </div>
  </div>
);

// Norme sui Resi e Diritto di Recesso (richiesto da Google Merchant Center)
export const ResiPage = () => {
  return (
    <LegalShell testid="resi-page">
      <h1 className="text-3xl font-extrabold text-white mb-2">↩️ Norme sui Resi e Diritto di Recesso</h1>
      <p className="text-sm text-gray-500 mb-8">Ultima modifica: 22 Giugno 2026</p>

      <div className="p-4 bg-pink-500/10 border border-pink-500/30 rounded-lg mb-6">
        <p className="text-gray-300 text-sm">
          <strong className="text-white">In breve:</strong> hai <strong className="text-white">14 giorni</strong> dalla ricezione per restituire un prodotto integro nell&apos;imballo originale.
          Le <strong className="text-white">spese di reso sono a carico del cliente</strong>. Il rimborso arriva entro <strong className="text-white">14 giorni</strong> dalla ricezione del reso, con la stessa modalità di pagamento usata per l&apos;acquisto.
        </p>
      </div>

      <div className="space-y-8 text-gray-400 leading-relaxed">

        <section>
          <SectionTitle>1. Periodo per esercitare il reso</SectionTitle>
          <p>
            Ai sensi degli articoli 52 e seguenti del D.Lgs. 206/2005 (Codice del Consumo), hai diritto di recedere dal contratto entro <strong className="text-white">14 giorni di calendario</strong> dalla data di ricezione fisica del prodotto, senza dover fornire alcuna motivazione.
          </p>
          <p className="mt-2">
            Il termine si considera rispettato se la comunicazione di recesso viene inviata prima della scadenza dei 14 giorni.
          </p>
        </section>

        <section>
          <SectionTitle>2. Condizioni del prodotto reso</SectionTitle>
          <p>Per essere accettato, il prodotto deve essere restituito:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li>Integro, non danneggiato e non usato oltre quanto necessario per verificarne natura e caratteristiche</li>
            <li>Nella confezione originale, comprensiva di tutti gli accessori, manuali, etichette ed eventuali sigilli</li>
            <li>Privo di segni evidenti di utilizzo (graffi, tracce, residui, ecc.)</li>
            <li>Sigilli non rimossi se trattasi di articoli sigillati (carte da gioco, modellini sigillati ecc.)</li>
          </ul>
        </section>

        <section>
          <SectionTitle>3. Come avviare un reso</SectionTitle>
          <ol className="list-decimal list-inside space-y-2 ml-2">
            <li>
              Contattaci entro 14 giorni dalla ricezione tramite uno dei seguenti canali:
              <div className="ml-6 mt-2 p-3 bg-[#0d0d14] border border-gray-800 rounded">
                <p>📧 Email: <a href="mailto:amm@edicolavillaricca.com" className="text-pink-400 hover:underline">amm@edicolavillaricca.com</a></p>
                <p>📞 Telefono / WhatsApp: <a href="tel:+393470808245" className="text-pink-400 hover:underline">+39 347 080 8245</a></p>
              </div>
            </li>
            <li>Indica numero d&apos;ordine, prodotto/i da restituire e motivo del reso.</li>
            <li>Riceverai conferma scritta e l&apos;indirizzo a cui inviare il pacco.</li>
            <li>Spedisci il pacco entro 14 giorni dalla nostra conferma, conservando la ricevuta di spedizione.</li>
          </ol>
        </section>

        <section>
          <SectionTitle>4. Chi paga le spese di spedizione del reso</SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 border border-red-500/30 bg-red-500/10 rounded-lg">
              <h3 className="font-semibold text-red-400 mb-2">Reso volontario (cambio idea)</h3>
              <p className="text-sm">Spese di spedizione di ritorno <strong className="text-white">a carico del cliente</strong>.</p>
            </div>
            <div className="p-4 border border-green-500/30 bg-green-500/10 rounded-lg">
              <h3 className="font-semibold text-green-400 mb-2">Prodotto difettoso, errato o danneggiato</h3>
              <p className="text-sm">Spese di reso <strong className="text-white">completamente a nostro carico</strong>.</p>
            </div>
          </div>
        </section>

        <section>
          <SectionTitle>5. Metodo e tempi di rimborso</SectionTitle>
          <p>
            Una volta ricevuto il prodotto e verificata la sua integrità, procediamo al rimborso entro <strong className="text-white">14 giorni</strong> dalla ricezione del reso.
          </p>
          <p className="mt-2">
            Il rimborso avviene <strong className="text-white">con la stessa modalità di pagamento</strong> utilizzata per l&apos;acquisto:
          </p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li>Pagamento con carta → riaccredito sulla carta originale</li>
            <li>Stripe / Klarna / Satispay → rimborso sul circuito originale</li>
            <li>Bonifico bancario → bonifico sul medesimo IBAN del versamento (o IBAN che ci comunicherai)</li>
          </ul>
          <p className="mt-2 text-sm text-gray-500">
            I tempi di accredito effettivo possono variare in funzione della banca o circuito di pagamento (di norma 3-7 giorni lavorativi aggiuntivi).
          </p>
        </section>

        <section>
          <SectionTitle>6. Esclusioni dal diritto di recesso</SectionTitle>
          <p>Ai sensi dell&apos;art. 59 del Codice del Consumo, sono <strong className="text-white">esclusi dal diritto di recesso</strong>:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 ml-2">
            <li>Prodotti confezionati su misura o chiaramente personalizzati</li>
            <li>Prodotti sigillati che siano stati aperti dopo la consegna (es. carte collezionabili sigillate, modellini in confezione sigillata aperta)</li>
            <li>Riviste e periodici (giornali, fumetti, riviste)</li>
          </ul>
        </section>

        <section>
          <SectionTitle>7. Sostituzione invece del rimborso</SectionTitle>
          <p>
            Se preferisci una sostituzione con un altro prodotto di pari valore (o pagando/ricevendo la differenza), comunicalo al momento della richiesta di reso. Saremo felici di aiutarti a trovare l&apos;articolo giusto.
          </p>
        </section>

        <section>
          <SectionTitle>8. Contatti per i resi</SectionTitle>
          <div className="p-4 bg-pink-500/10 border border-pink-500/30 rounded-lg">
            <p><strong className="text-white">Edicola Cerasuolo</strong></p>
            <p>📍 Corso Europa 175, 80010 Villaricca (NA)</p>
            <p>📞 +39 347 080 8245</p>
            <p>📧 <a href="mailto:amm@edicolavillaricca.com" className="text-pink-400 hover:underline">amm@edicolavillaricca.com</a></p>
            <p className="text-sm text-gray-500 mt-2">Orari negozio fisico: Lun-Sab 9:00 - 19:00 | Domenica chiuso</p>
          </div>
        </section>

      </div>
    </LegalShell>
  );
};

// Termini di Vendita Page
export const TerminiPage = () => {
  return (
    <LegalShell testid="termini-page">
      <h1 className="text-3xl font-extrabold text-white mb-2">📋 Termini e Condizioni di Vendita</h1>
      <p className="text-sm text-gray-500 mb-8">Ultima modifica: 15 Settembre 2024</p>

      <div className="space-y-6 text-gray-400 leading-relaxed">
        <section>
          <SectionTitle>1. Informazioni Generali</SectionTitle>
          <p>
            <strong className="text-white">Edicola Cerasuolo</strong> è un'edicola specializzata in modellismo Formula 1 e carte Pokémon,
            gestita con passione da Massimiliano Cerasuolo e Rita Colarusso.
          </p>
          <div className="mt-3 p-4 bg-pink-500/10 border border-pink-500/30 rounded-lg">
            <p><strong className="text-white">📍 Indirizzo:</strong> Corso Europa 175, Villaricca (NA)</p>
            <p><strong className="text-white">📞 Telefono:</strong> +39 347 080 8245</p>
            <p><strong className="text-white">📧 Email:</strong> amm@edicolavillaricca.com</p>
          </div>
        </section>

        <section>
          <SectionTitle>2. Modalità di Pagamento</SectionTitle>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 border border-gray-800 bg-[#0d0d14] rounded-lg">
              <h3 className="font-semibold text-white flex items-center mb-2">🏦 Bonifico Bancario</h3>
              <p className="text-sm text-gray-500">IBAN: IE67SUMU99036510351260<br/>Intestato a: Cerasuolo Massimiliano</p>
            </div>
            <div className="p-4 border border-gray-800 bg-[#0d0d14] rounded-lg">
              <h3 className="font-semibold text-white flex items-center mb-2">💳 Carta di Credito</h3>
              <p className="text-sm text-gray-500">Pagamento sicuro tramite Stripe con crittografia SSL</p>
            </div>
            <div className="p-4 border border-gray-800 bg-[#0d0d14] rounded-lg">
              <h3 className="font-semibold text-white flex items-center mb-2">🔷 Klarna</h3>
              <p className="text-sm text-gray-500">Paga dopo 30 giorni o in 3 rate</p>
            </div>
            <div className="p-4 border border-gray-800 bg-[#0d0d14] rounded-lg">
              <h3 className="font-semibold text-white flex items-center mb-2">🟥 Satispay</h3>
              <p className="text-sm text-gray-500">Pagamento mobile veloce e sicuro tramite app Satispay</p>
            </div>
          </div>
        </section>

        <section>
          <SectionTitle>3. Spedizioni e Consegne</SectionTitle>
          <ul className="list-disc list-inside space-y-2">
            <li><strong className="text-white">Spedizioni nazionali:</strong> Tempi di consegna 2-3 giorni lavorativi</li>
            <li><strong className="text-white">Spedizioni internazionali:</strong> Disponibili su richiesta, tempi variabili</li>
            <li><strong className="text-white">Costi di spedizione:</strong> Calcolati in base al peso e alla destinazione</li>
          </ul>
        </section>

        <section>
          <SectionTitle>4. Diritto di Recesso</SectionTitle>
          <p>
            In conformità al Codice del Consumo, hai diritto di recedere dal contratto entro 14 giorni
            dalla ricezione della merce, senza dover specificare il motivo. Per esercitare il diritto di recesso,
            contattaci al +39 347 080 8245 o via email a amm@edicolavillaricca.com.
          </p>
        </section>

        <section>
          <SectionTitle>5. Garanzie e Resi</SectionTitle>
          <ul className="list-disc list-inside space-y-2">
            <li>Tutti i prodotti sono coperti da garanzia legale di conformità</li>
            <li>I prodotti devono essere restituiti nelle stesse condizioni di ricezione</li>
            <li>Le spese di reso sono a carico del cliente, salvo difetti del prodotto</li>
            <li>Il rimborso avviene entro 14 giorni dalla ricezione del reso</li>
          </ul>
        </section>

        <section>
          <SectionTitle>6. Privacy e Newsletter</SectionTitle>
          <p>
            I tuoi dati personali sono trattati in conformità al GDPR. Iscrivendoti alla newsletter,
            acconsenti a ricevere comunicazioni sui nostri prodotti e servizi. Puoi cancellarti in qualsiasi momento
            utilizzando il link nelle email o contattandoci direttamente.
          </p>
        </section>

        <section>
          <SectionTitle>7. Contatti e Supporto</SectionTitle>
          <div className="p-4 bg-green-500/10 border border-green-500/30 rounded-lg">
            <p>
              Per qualsiasi domanda, problema o chiarimento sui nostri termini di vendita,
              non esitare a contattarci:
            </p>
            <div className="mt-3">
              <p>📞 <strong className="text-white">Telefono:</strong> +39 347 080 8245</p>
              <p>📧 <strong className="text-white">Email:</strong> amm@edicolavillaricca.com</p>
              <p>🕒 <strong className="text-white">Orari negozio fisico:</strong> Lun-Sab 9:00-19:00 | Domenica chiuso</p>
            </div>
          </div>
        </section>
      </div>

      <div className="mt-8 pt-6 border-t border-gray-800">
        <p className="text-center text-sm text-gray-600">
          © 2024 Edicola Cerasuolo - Tutti i diritti riservati
        </p>
      </div>
    </LegalShell>
  );
};
